import { render, staticRenderFns } from "./Entitlements.vue?vue&type=template&id=efa1f16a"
import script from "./Entitlements.ts?vue&type=script&lang=ts&external"
export * from "./Entitlements.ts?vue&type=script&lang=ts&external"
import style0 from "./Entitlements.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports